export const getBadgeColor = (
  type: 'SALES' | string,
  level: 'HIGH' | 'MEDIUM' | 'LOW',
) => {
  if (level === 'HIGH' && type === 'SALES') return 'GREEN';
  if (level === 'HIGH' && type !== 'SALES') return 'RED';
  if (level === 'MEDIUM') return 'YELLOW';

  return 'NEUTRAL';
};
